import { atom, selectorFamily } from 'recoil';
import getObeExistence from 'api/obes/getObeByRegNumberAndCountryCode';
export const isVehicleAlreadyRegisteredRequestId = atom({
  key: 'isVehicleAlreadyRegisteredRequestId',
  default: 0
});
const isVehicleAlreadyRegistered = selectorFamily({
  key: 'vehicleIsAwaitingShipping',
  get: ({
    registrationNumber,
    nationality
  }) => async ({
    get
  }) => {
    get(isVehicleAlreadyRegisteredRequestId);
    if (!registrationNumber || registrationNumber.length < 2) {
      return false;
    }
    const res = await getObeExistence(registrationNumber, nationality);
    return res;
  }
});
export default isVehicleAlreadyRegistered;